module.exports = __webpack_public_path__ + "static/assets/4ae0abc4caf9ad66c17f5c1212701924.png";